import { AvailabilityState } from '@notino/shared/definitions/types';

import { EShop } from '@containers/App/model';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { allowedCountries } from '../utils';

export const usePaymentMethodVisible = () => {
  const { shopId } = useApolloClientHeaders();
  const { pd_payment_methods } = useFeatureFlags();
  const { currentVariant } = useProductDetailContext();

  return (
    allowedCountries.includes(shopId as EShop) &&
    pd_payment_methods &&
    currentVariant.availability.state === AvailabilityState.CanBeBought
  );
};
